export * from './src/restaurants-operations-v1-operation-operations.meta.js';
